import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Icon, Translate } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.background.secondary
    }
  },
  text: { marginRight: theme.spacing(0.5) }
}));

export const ToggleButton = ({ isActive, handleClick }) => {
  const classes = useStyles();
  return (
    <Button className={classes.root} size='small' color='primary' onClick={handleClick}>
      {
        isActive
          ? (
            <>
              <Translate content='view_less_data' className={classes.text} />
              <Icon type='chevron-up' size='sm' />
            </>
            )
          : (
            <>
              <Translate content='view_all_data' className={classes.text} />
              <Icon type='chevron-down' size='sm' />
            </>
            )
      }
    </Button>
  );
};

ToggleButton.propTypes = {
  isActive: PropTypes.bool,
  handleClick: PropTypes.func
};

export default ToggleButton;
